import gql from "graphql-tag";

export const MY_TIMESHEET_GET_COSTS_LIST = gql`
  query listMyTimesheetCosts(
    $page: Int
    $pageSize: Int
    $sort: String
    $sortDirection: String
    $searchText: String
    $searchField: String
    $validity: String
  ) {
    listMyTimesheetCosts(
      page: $page
      pageSize: $pageSize
      sort: $sort
      sortDirection: $sortDirection
      searchText: $searchText
      searchField: $searchField
      validity: $validity
    ) {
      total
      totalPages
      page
      pageSize
      rows {
        _id
        name
        value
        billable
        description
        color
        validFrom
        validTo
        createdAt
        createdBy
        modifiedAt
        modifiedBy
        isDeleted
      }
    }
  }
`;
